import {SquareIcon} from '@/components/ui/icon/Icon'
import {StyledAgendaAppointmentStatus} from '@/features/agenda/components/agenda-appointment-status/style'
import {AgendaEventStatus} from '@/features/agenda/types'
import {
    agendaEventStatusMapToColor,
    agendaEventStatusMapToDarkColor,
    agendaEventStatusMapToLabel
} from '@/features/agenda/utils'
import {useTranslation} from '@/translations/i18n'

interface AgendaAppointmentStatusProps {
    status: AgendaEventStatus
}

export const AgendaAppointmentStatus = ({status}: AgendaAppointmentStatusProps) => {
    const {t} = useTranslation()

    return (
        <StyledAgendaAppointmentStatus align="center" gap={1} $color={agendaEventStatusMapToDarkColor[status]}>
            <SquareIcon size={12} color={agendaEventStatusMapToColor[status]} />
            <span>{t(agendaEventStatusMapToLabel[status])}</span>
        </StyledAgendaAppointmentStatus>
    )
}
